'use strict';

/**
 *
 * @name: nnLiveEvent
 *
 */

import DirectiveTemplate from './nn-live-event.directive.html';
import './nn-live-event.directive.scss';

function NnLiveEventDirective($sce, $translate) {

  'ngInject';

  return {
    restrict: 'A',
    scope: {
      content: '&',
    },
    template: DirectiveTemplate,
    link: function(scope, $element) {

      scope.translations = {
        liveEvent: $translate.instant('LIVE_EVENT')
      };
      scope.moduleConfig = scope.content();

      if (!scope.moduleConfig.jsonData || !scope.moduleConfig.jsonData.sources || !scope.moduleConfig.jsonData.sources[0]) {
        terminate();
      }

      scope.module = scope.moduleConfig.jsonData.sources[0];
      scope.module.iframeUrl = $sce.trustAsResourceUrl(scope.module.iframeUrl);

      /* private */

      function terminate() {

        scope.$destroy();
        $element.find('*').remove();
        $element.remove();
      }
    }
  };
}

export default NnLiveEventDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-live-event/nn-live-event.directive.js